
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("lqt9D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $f992a429587cad78$export$2e2bcd8739ae039; });

var $gNkVH = parcelRequire("gNkVH");

var $lrM5r = parcelRequire("lrM5r");

var $kOzMB = parcelRequire("kOzMB");

var $eAzuA = parcelRequire("eAzuA");

var $c3LVh = parcelRequire("c3LVh");

var $39c3M = parcelRequire("39c3M");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $hij2V = parcelRequire("hij2V");

var $lf4za = parcelRequire("lf4za");

var $jmxTP = parcelRequire("jmxTP");

var $wA1y2 = parcelRequire("wA1y2");

var $gzPfK = parcelRequire("gzPfK");

var $6m6U8 = parcelRequire("6m6U8");

var $ejpCV = parcelRequire("ejpCV");

var $c2FBh = parcelRequire("c2FBh");

var $lyJgN = parcelRequire("lyJgN");

var $cxxtC = parcelRequire("cxxtC");

var $lY5jW = parcelRequire("lY5jW");

var $1x79m = parcelRequire("1x79m");

var $lnbBQ = parcelRequire("lnbBQ");

var $g3io0 = parcelRequire("g3io0");

var $a48Mt = parcelRequire("a48Mt");
var $f992a429587cad78$var$_excluded = [
    "labelStack"
];
function $f992a429587cad78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f992a429587cad78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f992a429587cad78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f992a429587cad78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f992a429587cad78$var$createInteractionExtraLogPayload(_x, _x2, _x3, _x4) {
    return $f992a429587cad78$var$_createInteractionExtraLogPayload.apply(this, arguments);
}
function $f992a429587cad78$var$_createInteractionExtraLogPayload() {
    $f992a429587cad78$var$_createInteractionExtraLogPayload = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
        var _getTTAI, _getMostRecentVCRevis, _effectiveVCRevisionP, _effectiveVCRevisionP2, _lastInteractionFinis, _getTTAI2, _window$location;
        var config, end, start, ufoName, rate, type, abortReason, routeName, previousInteractionName, isPreviousInteractionAborted, abortedByInteractionName, knownSegments, minorInteractions, sanitisedUfoName, configRate, _config, pageVisibilityAtTTAI, isPageLoad, hasMinorInteractions, calculatePageVisibilityFromTheStartOfPageLoad, moreAccuratePageVisibilityAtTTAI, extraTTAI, newUFOName, finalVCMetrics, vcRevisionPayload, effectiveRevision, effectiveVCRevisionPayload, isVCCleanFor3p, vcAbortReasonFor3p, normalTTAI, lastInteractionFinishStart, lastInteractionFinishEnd, lastInteractionFinishVC90, lastInteractionFinishVCClean, lastInteractionFinishVCRev, lastInteractionFinishRevision, _effectiveVCRevisionP3, _effectiveVCRevisionP4, isThirdParty, filteredData, getDetailedInteractionMetrics, segments3p, segmentTree, payload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    config = (0, $03EZb.getConfig)();
                    if (config) {
                        _context.next = 3;
                        break;
                    }
                    throw Error('UFO Configuration not provided');
                case 3:
                    end = interaction.end, start = interaction.start, ufoName = interaction.ufoName, rate = interaction.rate, type = interaction.type, abortReason = interaction.abortReason, routeName = interaction.routeName, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName, knownSegments = interaction.knownSegments, minorInteractions = interaction.minorInteractions;
                    sanitisedUfoName = (0, $hij2V.sanitizeUfoName)(ufoName);
                    configRate = (0, $03EZb.getExtraInteractionRate)(sanitisedUfoName, type);
                    if ((0, $as5v9.default)(configRate)) {
                        _context.next = 8;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 8:
                    if (!(0, $39c3M.fg)('platform_ufo_disable_ufo_names_config')) {
                        _context.next = 12;
                        break;
                    }
                    _config = (0, $03EZb.getConfig)();
                    if (!(_config !== null && _config !== void 0 && _config.disabledUfoNames && _config !== null && _config !== void 0 && _config.disabledUfoNames.includes(sanitisedUfoName))) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 12:
                    pageVisibilityAtTTAI = (0, $jmxTP.default)(interaction);
                    isPageLoad = type === 'page_load' || type === 'transition';
                    hasMinorInteractions = minorInteractions !== undefined && minorInteractions.length > 0;
                    if (isPageLoad) {
                        _context.next = 17;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 17:
                    calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
                    moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $lf4za.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
                    extraTTAI = (_getTTAI = (0, $6m6U8.default)(interaction)) !== null && _getTTAI !== void 0 ? _getTTAI : undefined;
                    newUFOName = (0, $hij2V.sanitizeUfoName)(ufoName);
                    _context.next = 23;
                    return (0, $ejpCV.default)(interaction, true);
                case 23:
                    finalVCMetrics = _context.sent;
                    // Check if VC is clean and has valid metric
                    vcRevisionPayload = finalVCMetrics === null || finalVCMetrics === void 0 ? void 0 : finalVCMetrics['ufo:vc:rev'];
                    effectiveRevision = (_getMostRecentVCRevis = (0, $03EZb.getMostRecentVCRevision)(ufoName)) !== null && _getMostRecentVCRevis !== void 0 ? _getMostRecentVCRevis : (0, $03EZb.DEFAULT_TTVC_REVISION);
                    effectiveVCRevisionPayload = vcRevisionPayload === null || vcRevisionPayload === void 0 ? void 0 : vcRevisionPayload.find(function(_ref) {
                        var revision = _ref.revision;
                        return revision === effectiveRevision;
                    });
                    isVCCleanFor3p = (_effectiveVCRevisionP = effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload.clean) !== null && _effectiveVCRevisionP !== void 0 ? _effectiveVCRevisionP : false;
                    vcAbortReasonFor3p = (_effectiveVCRevisionP2 = effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload.abortReason) !== null && _effectiveVCRevisionP2 !== void 0 ? _effectiveVCRevisionP2 : undefined; // Always require valid TTAI
                    if (!(extraTTAI === undefined || typeof extraTTAI !== 'number')) {
                        _context.next = 31;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 31:
                    if (!isVCCleanFor3p) {
                        _context.next = 34;
                        break;
                    }
                    if (!((effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload['metric:vc90']) === undefined || typeof (effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload['metric:vc90']) !== 'number')) {
                        _context.next = 34;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 34:
                    if (!(!lastInteractionFinish || lastInteractionFinish !== null && lastInteractionFinish !== void 0 && lastInteractionFinish.abortReason || lastInteractionFinish !== null && lastInteractionFinish !== void 0 && (_lastInteractionFinis = lastInteractionFinish.errors) !== null && _lastInteractionFinis !== void 0 && _lastInteractionFinis.length)) {
                        _context.next = 36;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 36:
                    normalTTAI = (_getTTAI2 = (0, $6m6U8.default)(lastInteractionFinish)) !== null && _getTTAI2 !== void 0 ? _getTTAI2 : undefined;
                    lastInteractionFinishStart = typeof lastInteractionFinish.start === 'number' ? Math.round(lastInteractionFinish.start) : undefined;
                    lastInteractionFinishEnd = typeof lastInteractionFinish.end === 'number' ? Math.round(lastInteractionFinish.end) : undefined;
                    lastInteractionFinishVC90 = null;
                    lastInteractionFinishVCClean = false;
                    if (lastInteractionFinishVCResult) {
                        lastInteractionFinishVCRev = lastInteractionFinishVCResult['ufo:vc:rev'];
                        lastInteractionFinishRevision = lastInteractionFinishVCRev === null || lastInteractionFinishVCRev === void 0 ? void 0 : lastInteractionFinishVCRev.find(function(_ref2) {
                            var revision = _ref2.revision;
                            return revision === effectiveRevision;
                        });
                        if (lastInteractionFinishRevision !== null && lastInteractionFinishRevision !== void 0 && lastInteractionFinishRevision.clean) {
                            lastInteractionFinishVCClean = true;
                            lastInteractionFinishVC90 = lastInteractionFinishRevision['metric:vc90'];
                        }
                    } else if (normalTTAI !== undefined && typeof normalTTAI === 'number' && normalTTAI === extraTTAI) {
                        // Because TTAI is equal between with and without 3p, we can assume VC90 is also equal
                        lastInteractionFinishVC90 = (_effectiveVCRevisionP3 = effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload['metric:vc90']) !== null && _effectiveVCRevisionP3 !== void 0 ? _effectiveVCRevisionP3 : null;
                        lastInteractionFinishVCClean = (_effectiveVCRevisionP4 = effectiveVCRevisionPayload === null || effectiveVCRevisionPayload === void 0 ? void 0 : effectiveVCRevisionPayload.clean) !== null && _effectiveVCRevisionP4 !== void 0 ? _effectiveVCRevisionP4 : false;
                    }
                    // Helper function to check if labelStack contains third-party type
                    isThirdParty = function isThirdParty(labelStack) {
                        var _labelStack$some;
                        return (_labelStack$some = labelStack === null || labelStack === void 0 ? void 0 : labelStack.some(function(entry) {
                            return 'type' in entry && entry.type === 'third-party';
                        })) !== null && _labelStack$some !== void 0 ? _labelStack$some : false;
                    }; // Pre-filter 3p data
                    filteredData = {
                        errors: interaction.errors.filter(function(error) {
                            return isThirdParty(error.labelStack);
                        }),
                        spans: [].concat((0, $kOzMB.default)(interaction.spans), (0, $kOzMB.default)((0, $a48Mt.interactionSpans))).filter(function(span) {
                            return isThirdParty(span.labelStack);
                        }),
                        requestInfo: interaction.requestInfo.filter(function(req) {
                            return isThirdParty(req.labelStack);
                        }),
                        customTimings: interaction.customTimings.filter(function(timing) {
                            return isThirdParty(timing.labelStack);
                        }),
                        apdex: interaction.apdex.filter(function(apdex) {
                            return isThirdParty(apdex.labelStack);
                        }),
                        reactProfilerTimings: interaction.reactProfilerTimings.filter(function(timing) {
                            return isThirdParty(timing.labelStack);
                        }),
                        customData: interaction.customData.filter(function(data) {
                            return isThirdParty(data.labelStack);
                        }),
                        segments: knownSegments.filter(function(segment) {
                            return isThirdParty(segment.labelStack);
                        }),
                        marks: interaction.marks.filter(function(mark) {
                            return isThirdParty(mark.labelStack);
                        })
                    }; // Clear atlaskit spans after filtering
                    (0, $a48Mt.interactionSpans).length = 0;
                    // Detailed payload
                    getDetailedInteractionMetrics = function getDetailedInteractionMetrics() {
                        var _interaction$hold3pIn;
                        return {
                            errors: filteredData.errors.map(function(_ref3) {
                                var labelStack = _ref3.labelStack, others = (0, $lrM5r.default)(_ref3, $f992a429587cad78$var$_excluded);
                                return $f992a429587cad78$var$_objectSpread($f992a429587cad78$var$_objectSpread({}, others), {}, {
                                    labelStack: labelStack && (0, $hij2V.optimizeLabelStack)(labelStack, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type))
                                });
                            }),
                            holdActive: interaction.hold3pActive ? (0, $kOzMB.default)(interaction.hold3pActive.values()) : [],
                            holdInfo: (0, $cxxtC.optimizeHoldInfo)((_interaction$hold3pIn = interaction.hold3pInfo) !== null && _interaction$hold3pIn !== void 0 ? _interaction$hold3pIn : [], start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            spans: (0, $g3io0.optimizeSpans)(filteredData.spans, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            requestInfo: (0, $lnbBQ.optimizeRequestInfo)(filteredData.requestInfo, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            customTimings: (0, $lyJgN.optimizeCustomTimings)(filteredData.customTimings, start)
                        };
                    };
                    segments3p = !(0, $39c3M.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : filteredData.segments;
                    segmentTree = (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $hij2V.buildSegmentTree)(segments3p.map(function(segment) {
                        return segment.labelStack;
                    })) : {};
                    payload = {
                        actionSubject: 'experience',
                        action: 'measured',
                        eventType: 'operational',
                        source: 'measured',
                        tags: [
                            'observability'
                        ],
                        attributes: {
                            properties: $f992a429587cad78$var$_objectSpread($f992a429587cad78$var$_objectSpread({
                                // basic
                                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                                'event:product': config.product,
                                'event:schema': '1.0.0',
                                'event:sizeInKb': 0,
                                'event:source': {
                                    name: 'react-ufo/web',
                                    version: (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)
                                },
                                'event:region': config.region || 'unknown',
                                'experience:key': 'custom.interaction-extra-metrics',
                                'experience:name': newUFOName,
                                interactionMetrics: $f992a429587cad78$var$_objectSpread($f992a429587cad78$var$_objectSpread({
                                    namePrefix: config.namePrefix || '',
                                    segmentPrefix: config.segmentPrefix || '',
                                    interactionId: interactionId,
                                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                                    // raw interaction metrics
                                    rate: rate,
                                    routeName: routeName,
                                    type: type,
                                    abortReason: abortReason,
                                    previousInteractionName: previousInteractionName,
                                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                                    abortedByInteractionName: abortedByInteractionName,
                                    // performance
                                    end: Math.round(end),
                                    start: Math.round(start),
                                    'metric:ttai:3p': extraTTAI
                                }, finalVCMetrics), {}, {
                                    segments: (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $hij2V.getOldSegmentsLabelStack)(segments3p, interaction.type),
                                    marks: (0, $lY5jW.optimizeMarks)(filteredData.marks, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    apdex: (0, $c2FBh.optimizeApdex)(filteredData.apdex, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    reactProfilerTimings: (0, $1x79m.optimizeReactProfilerTimings)(filteredData.reactProfilerTimings, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    customData: filteredData.customData
                                }, getDetailedInteractionMetrics()),
                                vcClean: isVCCleanFor3p
                            }, vcAbortReasonFor3p !== undefined && {
                                vcAbortReason: vcAbortReasonFor3p
                            }), {}, {
                                hasMinorInteractions: hasMinorInteractions,
                                hasErrors: interaction.errors.length > 0,
                                'vc:effective:revision': effectiveRevision,
                                lastInteractionFinish: {
                                    start: lastInteractionFinishStart,
                                    end: lastInteractionFinishEnd,
                                    ttai: normalTTAI,
                                    vc90: lastInteractionFinishVC90,
                                    vcClean: lastInteractionFinishVCClean
                                }
                            })
                        }
                    };
                    payload.attributes.properties['event:sizeInKb'] = (0, $wA1y2.default)(payload.attributes.properties);
                    return _context.abrupt("return", payload);
                case 51:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $f992a429587cad78$var$_createInteractionExtraLogPayload.apply(this, arguments);
}
var $f992a429587cad78$export$2e2bcd8739ae039 = $f992a429587cad78$var$createInteractionExtraLogPayload;

});
parcelRegister("gzPfK", function(module, exports) {
$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", function () { return $c117ac018a6e5bfd$export$e919e900fc2d7fe8; });
$parcel$export(module.exports, "getReactUFOPayloadVersion", function () { return $c117ac018a6e5bfd$export$159168550e7449b8; });
var $c117ac018a6e5bfd$export$e919e900fc2d7fe8 = '2.0.0';
function $c117ac018a6e5bfd$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $c117ac018a6e5bfd$export$e919e900fc2d7fe8;
}

});



//# sourceMappingURL=create-interaction-extra-metrics-payload.566508d2.js.map
